/* flipsidehat.co, the shared frame: window.Flipside, and the markup wiring every page gets for free.
   SHOPIFY PORT (2026-09-26). What changed from the prototype (round3/site/assets/site.js), and why:
   - Loading. layout/theme.liquid loads this file with defer from the head. A section's inline script runs before it,
     so page scripts queue on the head shim: FlipsideReady(function (F) { ... }). The queue runs the moment the frame
     is wired, in order, before DOMContentLoaded (the prototype's timing: page scripts right after site.js).
   - Configuration comes from the layout's JSON island, <script type="application/json" id="flipside-config">: the
     asset base (Flipside.assetBase), versioned asset URLs (Flipside.assetMap), routes, the two hats, the support
     product and the approved copy. No Liquid lives in this file.
   - Flipside.asset(name) resolves against the theme's assets folder, so nothing depends on the page's own path.
   - The bag IS the Shopify cart (AJAX Cart API: /cart.js, /cart/add.js, /cart/change.js, /cart/update.js). The
     server is the only truth: every change re-renders from the cart the server returns, because line keys can change
     when an automatic discount (THE STACK) starts or stops applying. Nothing is assumed removed.
     Support rules (the prototype's): one support line in the bag (support lines show merged); support is never added
     without an XX; when the last XX leaves, the support leaves with it, with a toast; whole dollars only.
     fmc-cart contracts: aria-disabled busy state (focus never dropped), a polite status region, a recovery path
     (re-read the saved cart; if that fails too, say so and offer a reload), Check out is a plain link to /checkout
     (fs-analytics tracks the click), wallets come from content_for_additional_checkout_buttons.
   - Buy boxes are real product forms (snippets/cult-product-form.liquid). With JavaScript they add over AJAX and open
     the bag; a failed add stays on the page with the reason (Shopify's words when it sends them), focused, and a
     successful add stays successful even when the cart read after it fails (P33, P35). Without JavaScript the form
     posts to /cart/add.
   - The checkout and Shop Pay preview toasts are gone; the stock count stays out of the browser (the low-stock line
     is Liquid, snippets/cult-lowstock.liquid). window.FlipsideCartCount and window.openCartDrawer are provided for the
     legacy sections, and every [data-cart-count] shows the hat count.

   Flipside.reduce              true when the visitor asked for reduced motion (read once, at load)
   Flipside.hasIO               IntersectionObserver is available
   Flipside.isDesk()            true at 900px and wider
   Flipside.ready(fn)           run fn once the DOM is parsed
   Flipside.near(el, rootMargin, fn)   run fn(el) once, when el comes within rootMargin of the screen; returns cancel()
   Flipside.load(src)           promise; loads a script once.   Flipside.css(href): promise; loads a stylesheet once
   Flipside.asset(name)         absolute URL of a theme asset (Flipside.assetBase + name, or its versioned URL)
   Flipside.stock               { run: 250, lowAt: 25 }        Flipside.say(message): the toast (placed clear of every control)
   Flipside.bag                 open(from?) close() refresh() count() subtotal() lines() add(key, qty) addSupport(dollars)
                                buy(key, {support, from}) submit(form, submitter); count() is hats only
   Flipside.support             register({ amount: fn -> whole dollars | 0 | null, reset: fn }) for the Jamal page
   Flipside.motion              still() set(still) on(fn): the turning crest and rings, paused or not (remembered)
   Flipside.products            { usa250, xx }                 Flipside.POSTER: a still frame of the turning crest
   Flipside.wire(root)          wire markup hooks inside root (for markup a page adds after load)
   Flipside.vitrine             open(triggerEl) close()
*/
(function (win, doc) {
  'use strict';
  if (win.Flipside && win.Flipside.version) return;

  var mm = function (q) { return win.matchMedia ? win.matchMedia(q) : { matches: false }; };
  var reduce = mm('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in win;
  var deskQ = mm('(min-width:900px)');
  var noHover = mm('(hover: none)').matches;
  function isDesk() { return !!deskQ.matches; }
  function ready(fn) { if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', fn); else fn(); }
  function $(s, root) { return (root || doc).querySelector(s); }
  function $$(s, root) { return Array.prototype.slice.call((root || doc).querySelectorAll(s)); }
  function pick(s) { try { return s ? $$(s) : []; } catch (e) { return []; } }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* ---------- configuration: the layout's JSON island ---------- */
  var CFG = {};
  try { var cfgEl = doc.getElementById('flipside-config'); if (cfgEl) CFG = JSON.parse(cfgEl.textContent) || {}; } catch (e) { CFG = {}; }
  var ROUTES = CFG.routes || {};
  var ROOT = ROUTES.root || (win.Shopify && win.Shopify.routes && win.Shopify.routes.root) || '/';
  if (ROOT.charAt(ROOT.length - 1) !== '/') ROOT += '/';
  var COPY = CFG.copy || {};

  /* ---------- near: build heavy things only as they come near ---------- */
  function near(el, margin, fn) {
    if (typeof margin === 'function') { fn = margin; margin = '600px 0px'; }
    if (!el || typeof fn !== 'function') return function () {};
    var done = false;
    var go = function () { if (!done) { done = true; fn(el); } };
    if (!hasIO) { go(); return function () {}; }
    var io = new IntersectionObserver(function (es) {
      if (es.some(function (x) { return x.isIntersecting; })) { io.disconnect(); go(); }
    }, { rootMargin: margin || '0px' });
    io.observe(el);
    return function () { io.disconnect(); done = true; };
  }

  /* ---------- assets: the theme's assets folder, never the page's own path ---------- */
  function abs(u) { try { return new URL(u, doc.baseURI).href; } catch (e) { return u; } }
  var SELF = (doc.currentScript && doc.currentScript.src) || '';
  var ASSET_BASE = CFG.assetBase || (SELF ? SELF.replace(/[?#].*$/, '').replace(/[^\/]*$/, '') : '/');
  if (ASSET_BASE.indexOf('//') === 0) ASSET_BASE = win.location.protocol + ASSET_BASE;
  /* versioned URLs: the layout's own few, plus every section's <script type="application/json" data-flipside-assets>
     map. An asset without one still resolves (assetBase + name), but that URL has no ?v= and the CDN lets browsers
     keep it for a year, so on a preview theme the frame names it in the console for the page agent to add. */
  var ASSET_MAP = {}, warned = {};
  function mergeMaps() {
    var m = CFG.assets || {};
    Object.keys(m).forEach(function (k) { ASSET_MAP[k] = m[k]; });
    $$('script[type="application/json"][data-flipside-assets]').forEach(function (s) {
      if (s.__fsMap) return; s.__fsMap = true;
      try { var o = JSON.parse(s.textContent) || {}; Object.keys(o).forEach(function (k) { ASSET_MAP[k] = o[k]; }); } catch (e) {}
    });
  }
  mergeMaps();
  function asset(name) {
    name = String(name || '').replace(/^\.?\/?assets\//, '');
    if (!Object.prototype.hasOwnProperty.call(ASSET_MAP, name)) mergeMaps();
    if (Object.prototype.hasOwnProperty.call(ASSET_MAP, name)) return abs(ASSET_MAP[name]);
    if (!warned[name] && win.Shopify && win.Shopify.theme && win.Shopify.theme.role !== 'main' && win.console && console.warn) {
      warned[name] = 1; console.warn('Flipside.asset: ' + name + ' has no versioned URL in an asset map');
    }
    try { return new URL(name, ASSET_BASE).href; } catch (e) { return ASSET_BASE + name; }
  }
  var scripts = {}, sheets = {};
  function load(src) {
    var key = abs(src);
    if (scripts[key]) return scripts[key];
    scripts[key] = new Promise(function (resolve, reject) {
      var s = doc.createElement('script');
      s.src = key;
      s.onload = function () { resolve(); };
      s.onerror = function () { delete scripts[key]; s.remove(); reject(new Error('Flipside.load failed: ' + src)); };
      doc.head.appendChild(s);
    });
    return scripts[key];
  }
  function css(href) {
    var key = abs(href);
    if (sheets[key]) return sheets[key];
    sheets[key] = new Promise(function (resolve, reject) {
      var have = $$('link[rel="stylesheet"]').filter(function (l) { return l.href === key; })[0];
      var fail = function (l) { return function () { delete sheets[key]; if (l !== have) l.remove(); reject(new Error('Flipside.css failed: ' + href)); }; };
      if (have) {
        if (have.sheet) { resolve(); return; }
        have.addEventListener('load', function () { resolve(); });
        have.addEventListener('error', fail(have));
        return;
      }
      var l = doc.createElement('link');
      l.rel = 'stylesheet'; l.href = key;
      l.onload = function () { resolve(); };
      l.onerror = fail(l);
      doc.head.appendChild(l);
    });
    return sheets[key];
  }

  /* ---------- the truth: no stock count ships to the browser ---------- */
  /* Section 10.5: the low-stock line ("Only N left.") is written by Liquid (snippets/cult-lowstock.liquid) from the live
     inventory, and only at 25 or fewer. This file never writes a count. */
  var stock = Object.freeze({ run: 250, lowAt: 25 });
  var POSTER = asset('fmc-vault-mark2-poster.webp');
  /* the two hats, as the layout describes them (handle, variant, the bag's name, note, photo and page) */
  var products = {};
  var byHandle = {};
  (function () {
    var P = CFG.products || {};
    Object.keys(P).forEach(function (k) {
      var p = P[k] || {};
      var o = Object.freeze({ key: k, handle: p.handle, variant: p.variant, name: p.name, price: p.price, note: p.note || '', preorderNote: p.preorderNote || '', url: p.url,
        img: p.img ? abs(p.img) : '', preorder: !!p.preorder, available: p.available !== false });
      products[k] = o;
      if (o.handle) byHandle[o.handle] = o;
    });
    Object.freeze(products);
  })();
  var SUPPORT = { handle: (CFG.support && CFG.support.handle) || 'jamal-roberts-nil-extra-contribution',
    variant: (CFG.support && CFG.support.variant) || null, available: !!(CFG.support && CFG.support.available),
    name: 'Extra support for Jamal', note: '100% goes to Jamal.', foot: 'Extra support ships nothing. 100% goes to Jamal.',
    gone: 'Extra support rides with the hat, so it came off too.' };
  var SAY = {
    added: '[name] is in your bag.',
    addedCount: '[name] is in your bag. [items]. Subtotal [subtotal].',
    qty: '[name], quantity [qty]. Subtotal [subtotal].',
    removed: '[name] removed. Subtotal [subtotal].',
    emptied: '[name] removed. The bag is empty.',
    addFailed: 'That didn’t go through. Try again.',
    supportUnavailable: 'Extra support is not available right now. Set support to none to continue.'
  };
  function fill(t, map) { return t.replace(/\[(\w+)\]/g, function (m, k) { return Object.prototype.hasOwnProperty.call(map, k) ? map[k] : m; }); }
  function isProduct(k) { return typeof k === 'string' && Object.prototype.hasOwnProperty.call(products, k); }

  /* ---------- toast: it never covers a control. That is every link and every focusable control on show (buttons,
     fields, summaries, anything with a tabindex of 0 or more, and the button, link, checkbox, switch, tab and slider
     roles), plus the header and the sticky bar. With the bag open it stays inside the bag's panel, 8px clear of every
     control in it, and off the bag's lines and totals where there is room; otherwise it stays 8px clear of every
     control on the screen. It sits as near its usual place (84px above the bottom) as it can, trying 8px steps up and
     down; if every place covers something, it takes the one that covers least, and a control weighs a hundred times
     more than text. A control counts only where it shows: inside the screen, and inside any box that clips it (a
     scrolled list, say). ---------- */
  var toastT = 0;
  var TOAST_CONTROLS = 'a[href], button, input, select, textarea, summary, [tabindex], [contenteditable]:not([contenteditable="false"]), ' +
    '[role="button"], [role="link"], [role="checkbox"], [role="switch"], [role="tab"], [role="slider"]';
  var NATIVE = 'a[href], button, input, select, textarea, summary';
  var VIS = { opacityProperty: true, visibilityProperty: true, checkOpacity: true, checkVisibilityCSS: true };
  function shownRect(el, vw, vh) {
    var r = el.getBoundingClientRect(), l = Math.max(r.left, 0), t = Math.max(r.top, 0), rr = Math.min(r.right, vw), b = Math.min(r.bottom, vh);
    if (rr - l < 2 || b - t < 2) return null;   /* off the screen */
    if (el.closest('[hidden], [inert], .toast')) return null;
    if (el.hasAttribute('tabindex') && +el.getAttribute('tabindex') < 0 && !el.matches(NATIVE)) return null;
    if (el.checkVisibility && !el.checkVisibility(VIS)) return null;
    for (var n = el; n && n !== doc.body && n.nodeType === 1; n = n.parentElement) {
      var cs = win.getComputedStyle(n);
      if (!el.checkVisibility && (cs.display === 'none' || cs.visibility === 'hidden' || cs.opacity === '0')) return null;
      if (cs.position === 'fixed') break;   /* a fixed box escapes the clips above it */
      if (n !== el && (cs.overflowX !== 'visible' || cs.overflowY !== 'visible')) {
        var c = n.getBoundingClientRect();
        l = Math.max(l, c.left); t = Math.max(t, c.top); rr = Math.min(rr, c.right); b = Math.min(b, c.bottom);
      }
      if (rr - l < 2 || b - t < 2) return null;
    }
    return rr - l >= 2 && b - t >= 2 ? { left: l, top: t, right: rr, bottom: b } : null;
  }
  function rectsOf(els, pad, weight, vw, vh) {
    var out = [];
    els.forEach(function (el) {
      var r = shownRect(el, vw, vh);
      if (r) out.push({ l: r.left - pad / 2, r: r.right + pad / 2, t: r.top - pad, b: r.bottom + pad, w: weight });
    });
    return out;
  }
  function placeToast(t) {
    var vw = doc.documentElement.clientWidth, vh = win.innerHeight;
    var panel = drawer && !drawer.hidden ? $('.drawer__panel', drawer) : null;
    var a = panel ? panel.getBoundingClientRect() : { left: 0, right: vw, top: 0, bottom: vh };
    t.style.left = panel ? Math.round(a.left + 16) + 'px' : '';
    t.style.right = panel ? Math.round(vw - a.right + 16) + 'px' : '';
    t.style.maxWidth = panel ? Math.max(120, Math.round(a.right - a.left - 32)) + 'px' : '';
    var w = t.offsetWidth, h = t.offsetHeight, x0 = (a.left + a.right - w) / 2, x1 = x0 + w;
    var keep = panel ? rectsOf($$(TOAST_CONTROLS, panel), 8, 100, vw, vh).concat(rectsOf($$('.line, .drawer__sub, .drawer__note', panel), 0, 1, vw, vh))
      : rectsOf($$('.bar, .sticky.on'), 8, 100, vw, vh).concat(rectsOf($$(TOAST_CONTROLS), 8, 100, vw, vh));
    var lo = a.top + 8, hi = a.bottom - h - 8, pref = Math.min(hi, Math.max(lo, a.bottom - 84 - h)), best = pref, least = Infinity;
    var cover = function (y) {
      return keep.reduce(function (n, k) {
        var ox = Math.min(x1, k.r) - Math.max(x0, k.l), oy = Math.min(y + h, k.b) - Math.max(y, k.t);
        return ox > 0 && oy > 0 ? n + ox * oy * k.w : n;
      }, 0);
    };
    for (var d = 0; d <= vh; d += 8) {
      var ys = d ? [pref - d, pref + d] : [pref];
      for (var i = 0; i < ys.length; i++) {
        var y = ys[i]; if (y < lo || y > hi) continue;
        var c = cover(y); if (c < least) { least = c; best = y; }
        if (!c) { d = vh + 1; break; }
      }
    }
    t.style.top = Math.round(best) + 'px'; t.style.bottom = 'auto';
  }
  function say(m) {
    var t = $('#toast'); if (!t) return;
    t.textContent = m;
    try { placeToast(t); } catch (e) {}
    t.classList.add('on');
    clearTimeout(toastT); toastT = setTimeout(function () { t.classList.remove('on'); }, 2600);
  }

  /* ---------- menu: opening it puts focus on its first item, and Tab stays inside it (its links and the Close button
     that opened it). Esc closes it and hands focus back to the Menu button. ---------- */
  var setMenu = function () {};
  function wireMenu() {
    var btn = $('.menu-btn'), menu = $('#menu'), scrim = $('#menu-scrim'), bar = $('.bar');
    if (!btn || !menu) return;
    var key = function (e) {
      if (e.key === 'Escape') { e.preventDefault(); set(false); btn.focus(); return; }
      if (e.key !== 'Tab') return;
      var f = [btn].concat($$('a[href]', menu)), n = f.length, i = f.indexOf(doc.activeElement);
      e.preventDefault();
      f[i < 0 ? (e.shiftKey ? n - 1 : 1 % n) : (i + (e.shiftKey ? n - 1 : 1)) % n].focus();
    };
    var set = function (open) {
      if (!open && menu.hidden) return;
      btn.setAttribute('aria-expanded', String(open)); btn.textContent = open ? 'Close' : 'Menu';
      var top = (bar ? bar.getBoundingClientRect().bottom : 0) + 'px';
      menu.style.top = top; if (scrim) scrim.style.top = top;
      var inside = menu.contains(doc.activeElement);
      menu.hidden = !open; if (scrim) scrim.hidden = !open;
      if (open) { doc.addEventListener('keydown', key); var first = $('a[href]', menu); if (first) first.focus(); }
      else { doc.removeEventListener('keydown', key); if (inside) btn.focus(); }
    };
    setMenu = set;
    btn.addEventListener('click', function () { set(btn.getAttribute('aria-expanded') !== 'true'); });
    menu.addEventListener('click', function (e) { if (e.target.closest('a')) set(false); });
    if (scrim) scrim.addEventListener('click', function () { set(false); });
    var toDesk = function () { if (isDesk()) set(false); };
    if (deskQ.addEventListener) deskQ.addEventListener('change', toDesk); else if (deskQ.addListener) deskQ.addListener(toDesk);
  }

  /* ================= THE BAG: the Shopify cart ================= */
  var cart = null;              /* the last cart the server confirmed */
  var partial = null;           /* lines the store confirmed in an add, when the cart read after it failed */
  var knownCount = typeof CFG.bagCount === 'number' ? CFG.bagCount : null;
  var busy = false, blocked = false;
  var drawer = null, lastFocus = null, refreshing = null;
  var supportHook = null;
  function url(path) { return ROOT + path; }
  function whole(n, max) { return typeof n === 'number' && isFinite(n) && Math.floor(n) === n && n >= 1 && n <= max; }
  function money(cents) {
    var n = Math.max(0, Math.round(Number(cents) || 0)), d = Math.floor(n / 100), c = n % 100;
    return '$' + String(d).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + (c ? '.' + (c < 10 ? '0' : '') + c : '');
  }
  function isSupport(it) { return !!it && it.handle === SUPPORT.handle; }
  function isXX(it) { return !!it && !!products.xx && it.handle === products.xx.handle; }
  function hatsIn(c) { return c && Array.isArray(c.items) ? c.items.reduce(function (n, it) { return n + (isSupport(it) ? 0 : (Number(it.quantity) || 0)); }, 0) : 0; }
  function hasXX(c) { return !!c && c.items.some(isXX); }
  function supportKeys(c) { return c ? c.items.filter(isSupport).map(function (it) { return it.key; }) : []; }
  /* the store's cart, checked before it is trusted (fmc-cart's validator) */
  function validCart(c) {
    if (!c || !Array.isArray(c.items) || !Number.isSafeInteger(c.item_count) || c.item_count < 0 || !Number.isSafeInteger(c.total_price) || c.total_price < 0) return false;
    var keys = {}, count = 0;
    for (var i = 0; i < c.items.length; i++) {
      var it = c.items[i];
      if (!it || typeof it.key !== 'string' || !it.key || keys[it.key] || !Number.isSafeInteger(it.quantity) || it.quantity <= 0 ||
        !Number.isSafeInteger(it.final_line_price) || it.final_line_price < 0) return false;
      keys[it.key] = true; count += it.quantity;
    }
    return count === c.item_count;
  }
  function failure(res, fallback) {
    var b = res && res.body, reason = '';
    var challenged = !!(res && res.challenged);
    if (b && typeof b.description === 'string' && b.description.trim()) reason = b.description;
    else if (b && typeof b.message === 'string' && b.message.trim() && res.status !== 404) reason = b.message;
    var e = new Error('cart request not confirmed');
    e.reason = (reason || '').trim().slice(0, 400);
    e.fallback = fallback;
    e.challenged = challenged;
    return e;
  }
  function request(path, body) {
    var opts = { method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } };
    if (body) { opts.headers['Content-Type'] = 'application/json'; opts.body = JSON.stringify(body); }
    return fetch(url(path), opts).then(function (r) {
      /* the store's bot check answers a cart request with a page to verify the connection, which only a page load can
         pass (a real browser does it on its own); the caller then hands over to a normal page load */
      var challenged = (r.status === 429 || r.status === 403) && /challenge/i.test(r.headers.get('cf-mitigated') || '');
      return r.json().catch(function () { return null; }).then(function (b) { return { ok: r.ok, status: r.status, body: b, challenged: challenged }; });
    });
  }
  function readCart() {
    return request('cart.js').then(function (res) {
      if (!res.ok || !validCart(res.body)) throw failure(res);
      return res.body;
    });
  }
  /* every [data-cart-count] (the header's Bag count, and any a legacy section keeps) shows the hats in the bag */
  function paintCount(n) {
    if (typeof n !== 'number') return;
    knownCount = n;
    $$('.bag-n, [data-cart-count]').forEach(function (b) { if (b.textContent !== String(n)) b.textContent = n; });
  }
  function setCart(c) { cart = c; partial = null; paintCount(hatsIn(c)); }
  /* the bag reads the server again; one read at a time */
  function refresh() {
    if (refreshing) return refreshing;
    refreshing = readCart().then(function (c) { refreshing = null; setCart(c); render(); return c; },
      function (e) { refreshing = null; throw e; });
    return refreshing;
  }

  /* ---------- lines ---------- */
  function sized(u, w) {
    if (!u) return '';
    if (u.indexOf('//') === 0) u = 'https:' + u;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function noteFor(it, p) {
    var pre = it.properties && it.properties['Order type'] === 'Preorder';
    if (p && p.preorderNote && (p.preorder || pre)) return p.preorderNote;
    if (p && p.note) return p.note;
    return it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
  }
  function viewLines(items) {
    var out = [], sup = null;
    items.forEach(function (it) {
      if (isSupport(it)) {
        if (!sup) { sup = { support: true, keys: [], cents: 0 }; }
        sup.keys.push(it.key); sup.cents += Number(it.final_line_price) || 0;
        return;
      }
      var p = byHandle[it.handle];
      out.push({ key: it.key, handle: it.handle || '', variant: String(it.variant_id || ''), qty: it.quantity,
        name: p && p.name ? p.name : (it.product_title || it.title || ''), note: noteFor(it, p),
        img: p && p.img ? p.img : sized((it.featured_image && it.featured_image.url) || it.image || '', 144),
        cents: Number(it.final_line_price) || 0, was: Number(it.original_line_price) > Number(it.final_line_price) ? Number(it.original_line_price) : 0 });
    });
    if (sup) out.push(sup);
    return out;
  }
  function lineHTML(l) {
    if (l.support) {
      var d = money(l.cents);
      return '<li class="line line--support" data-support><span class="line__img line__img--support" aria-hidden="true"><b>' + d + '</b></span>' +
        '<div><p class="line__name">' + esc(SUPPORT.name) + '<span class="line__note">' + esc(SUPPORT.note) + '</span></p>' +
        '<div class="qty qty--solo"><button type="button" class="rm" data-act="rm-support" aria-label="Remove ' + esc(SUPPORT.name) + ', ' + d + '">Remove</button></div></div>' +
        '<p class="line__price">' + d + '</p></li>';
    }
    var who = ' data-key="' + esc(l.key) + '" data-handle="' + esc(l.handle) + '" data-variant="' + esc(l.variant) + '"';
    return '<li class="line"' + who + '><span class="line__img">' + (l.img ? '<img src="' + esc(l.img) + '" width="72" height="72" alt="">' : '') + '</span>' +
      '<div><p class="line__name">' + esc(l.name) + (l.note ? '<span class="line__note">' + esc(l.note) + '</span>' : '') + '</p>' +
      '<div class="qty"><button type="button" data-act="dec"' + who + ' aria-label="One fewer ' + esc(l.name) + '">&#8722;</button>' +
      '<output aria-label="Quantity">' + l.qty + '</output>' +
      '<button type="button" data-act="inc"' + who + ' aria-label="One more ' + esc(l.name) + '">+</button>' +
      '<button type="button" class="rm" data-act="rm"' + who + ' aria-label="Remove ' + esc(l.name) + '">Remove</button></div></div>' +
      '<p class="line__price">' + (l.was ? '<s class="line__was">' + money(l.was) + '</s>' : '') + money(l.cents) + '</p></li>';
  }
  /* the returns note is about hats; with a support line in the bag, one more line says what support is */
  function supportNote(show) {
    var n = $('#cart-support-note'), base = $('#cart-note');
    if (!n && show && base) {
      n = doc.createElement('p'); n.className = 'drawer__note'; n.id = 'cart-support-note'; n.textContent = SUPPORT.foot;
      base.parentNode.insertBefore(n, base.nextSibling);
    }
    if (n) n.hidden = !show;
  }
  function emptyHTML() {
    var u = products.usa250 ? products.usa250.url : url('collections/all');
    return '<li class="drawer__empty">Nothing in here yet. <a href="' + esc(u) + '">Shop the USA 250</a>.</li>';
  }
  function renderList() {
    drawer = drawer || $('#cart');
    var list = $('#cart-items'), sub = $('#cart-sub'), subRow = sub ? sub.closest('.drawer__sub') : null;
    var items = cart ? cart.items : (partial || []);
    var lines = viewLines(items);
    /* before the first read, a page that says the bag holds hats shows nothing rather than "Nothing in here yet" */
    var waiting = !cart && !partial && knownCount !== 0;
    if (list) list.innerHTML = lines.length ? lines.map(lineHTML).join('') : (waiting ? '' : emptyHTML());
    if (sub) sub.textContent = cart ? money(cart.total_price) : '';
    if (subRow) subRow.hidden = !cart;
    supportNote(lines.some(function (l) { return l.support; }));
    var empty = !items.length;
    /* nothing to check out: Check out rests and the wallets hide */
    setCheckout(!empty && !busy && !blocked);
    var w = drawer && $('[data-cart-wallets]', drawer); if (w) w.hidden = empty;
  }
  /* Check out is a plain link to /checkout. It rests by losing its href (dimmed, aria-disabled): fs-analytics' capture
     listener acts on any /checkout link before this file could stop the click. */
  function setCheckout(on) {
    if (!drawer) return;
    $$('a[data-checkout]', drawer).forEach(function (a) {
      if (on) {
        if (!a.getAttribute('href')) a.setAttribute('href', a.getAttribute('data-href') || url('checkout'));
        a.removeAttribute('aria-disabled'); a.removeAttribute('role');
      } else {
        if (a.getAttribute('href')) a.setAttribute('data-href', a.getAttribute('href'));
        a.removeAttribute('href'); a.setAttribute('aria-disabled', 'true'); a.setAttribute('role', 'link');
      }
    });
  }
  function render() {
    paintCount(cart ? hatsIn(cart) : knownCount);
    if (drawer && !drawer.hidden) renderList();
  }
  /* the polite region inside the bag (never hidden, empty at load): clear, then write on the next tick, so an
     identical repeat is announced again */
  function announce(m) {
    var live = $('#cart-live'); if (!live || !m) return;
    live.textContent = '';
    setTimeout(function () { live.textContent = m; }, 60);
  }
  function bagError(m, canReload) {
    var e = $('#cart-error'), r = $('[data-cart-reload]');
    if (e) { e.hidden = !m; e.textContent = m || ''; }
    if (r) r.hidden = !canReload;
  }
  function setBusy(v) {
    busy = v;
    if (!drawer) return;
    drawer.setAttribute('aria-busy', String(v));
    /* never disabled: a disabled control leaves the accessibility tree and focus falls to the body. aria-disabled and
       the busy guard refuse the press */
    $$('.drawer__items button', drawer).forEach(function (b) {
      if (v || blocked) b.setAttribute('aria-disabled', 'true'); else b.removeAttribute('aria-disabled');
    });
    if (v || blocked) setCheckout(false);
    if (!v) renderList();
  }
  /* the pressed control, found again after a re-render (keys can change, so by product and action) */
  function controlOf(el) {
    if (!el || !el.getAttribute || !drawer || !drawer.contains(el)) return null;
    var act = el.getAttribute('data-act');
    return act ? { act: act, handle: el.getAttribute('data-handle') || '', variant: el.getAttribute('data-variant') || '' } : null;
  }
  function restoreFocus(t) {
    var list = $('#cart-items'), el = null;
    if (t && list && t.act !== 'rm-support') {
      el = $$('button[data-act="' + t.act + '"]', list).filter(function (b) {
        return b.getAttribute('data-variant') === t.variant && b.getAttribute('data-handle') === t.handle;
      })[0] || null;
    }
    /* the same control on the same hat, else Close (the prototype's rule) */
    (el || $('.x', drawer)).focus();
  }
  /* support rides with the hat: when the last XX leaves the bag, the support leaves with it (and says so) */
  function tidy(c, loud) {
    if (!c || hasXX(c) || !supportKeys(c).length) return Promise.resolve(c);
    var updates = {};
    supportKeys(c).forEach(function (k) { updates[k] = 0; });
    return request('cart/update.js', { updates: updates }).then(function (res) {
      if (!res.ok || !validCart(res.body)) throw failure(res);
      if (loud) say(SUPPORT.gone);
      return res.body;
    });
  }
  function lineName(c, key) {
    var it = c && c.items.filter(function (x) { return x.key === key; })[0];
    if (!it) return '';
    var p = byHandle[it.handle];
    return p && p.name ? p.name : (it.product_title || it.title || '');
  }
  function saidAfter(c, name, qty, handle, variant) {
    var sub = money(c.total_price);
    if (qty > 0) {
      var now = c.items.filter(function (it) { return String(it.variant_id) === String(variant) && it.handle === handle; })
        .reduce(function (n, it) { return n + it.quantity; }, 0);
      return fill(SAY.qty, { name: name, qty: String(now || qty), subtotal: sub });
    }
    return fill(c.items.length ? SAY.removed : SAY.emptied, { name: name, subtotal: sub });
  }
  /* when a change is not confirmed: show the store's reason (or the approved line), read the saved cart again, and
     show it; if that read fails too, say so and offer a reload (the P20 recovery path, in the bag) */
  var reloadTo = '';
  function recover(err) {
    var reason = (err && err.reason) || COPY.failed || 'The requested cart change could not be confirmed.';
    reloadTo = err && err.challenged ? url('cart') : '';
    setBusy(false);
    return readCart().then(function (c) {
      setCart(c); renderList();
      bagError(reason + (COPY.review ? ' ' + COPY.review : ''), false);
      var e = $('#cart-error'); if (e) e.focus();
    }, function (e2) {
      if (e2 && e2.challenged) reloadTo = url('cart');
      blocked = true; setBusy(false);
      bagError(reason + ' ' + (COPY.unconfirmed || 'We could not confirm the saved cart. Reload it before checkout.'), true);
      var e = $('#cart-error'); if (e) e.focus();
    });
  }
  function change(updates, target, name, qty, handle, variant) {
    if (busy || blocked) return;
    bagError('');
    setBusy(true);
    var path = updates.single ? 'cart/change.js' : 'cart/update.js';
    var body = updates.single ? { id: updates.single, quantity: qty } : { updates: updates.map };
    request(path, body).then(function (res) {
      if (!res.ok || !validCart(res.body)) throw failure(res);
      return tidy(res.body, true);
    }).then(function (c) {
      setCart(c);
      setBusy(false);
      restoreFocus(target);
      announce(name ? saidAfter(c, name, qty, handle, variant) : '');
    }).catch(recover);
  }
  function onBagClick(e) {
    var b = e.target.closest('button[data-act]'); if (!b) return;
    e.preventDefault();
    if (busy || blocked || !cart) return;
    var act = b.getAttribute('data-act'), target = controlOf(b);
    if (act === 'rm-support') {
      var map = {}; supportKeys(cart).forEach(function (k) { map[k] = 0; });
      change({ map: map }, target, SUPPORT.name, 0, SUPPORT.handle, String(SUPPORT.variant || ''));
      return;
    }
    var key = b.getAttribute('data-key'), it = cart.items.filter(function (x) { return x.key === key; })[0];
    if (!it) { refresh().catch(function () {}); return; }
    var qty = act === 'inc' ? it.quantity + 1 : act === 'dec' ? it.quantity - 1 : 0;
    if (qty < 0) qty = 0;
    change({ single: key }, target, lineName(cart, key), qty, it.handle, String(it.variant_id));
  }
  function focusables(root) {
    return $$('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), iframe, [tabindex]:not([tabindex="-1"])', root)
      .filter(function (x) { return (x.offsetParent !== null || x === doc.activeElement) && x.getAttribute('tabindex') !== '-1'; });
  }
  function trap(e) {
    if (e.key === 'Escape') { e.preventDefault(); bag.close(); return; }
    if (e.key !== 'Tab') return;
    var f = focusables(drawer); if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && doc.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && doc.activeElement === last) { e.preventDefault(); first.focus(); }
    else if (!drawer.contains(doc.activeElement)) { e.preventDefault(); first.focus(); }
  }
  /* ---------- adding: buy forms, and the API for page scripts ---------- */
  function itemFromForm(form) {
    var fd = new FormData(form), item = { quantity: 1 }, props = {};
    fd.forEach(function (v, k) {
      if (k === 'id') item.id = Number(v) || v;
      else if (k === 'quantity') item.quantity = Math.max(1, parseInt(v, 10) || 1);
      else if (k === 'selling_plan' && v) item.selling_plan = v;
      else { var m = /^properties\[(.+)\]$/.exec(k); if (m && v !== '') props[m[1]] = v; }
    });
    if (Object.keys(props).length) item.properties = props;
    return item;
  }
  function itemFor(key, qty) {
    var p = products[key]; if (!p || !p.variant) return null;
    var item = { id: Number(p.variant), quantity: qty };
    if (p.preorder) item.properties = { 'Order type': 'Preorder' };
    return item;
  }
  function addedName(added, fallback) {
    var it = added && added.items && added.items[0] ? added.items[0] : added;
    if (it && it.handle && byHandle[it.handle] && byHandle[it.handle].name) return byHandle[it.handle].name;
    return (it && (it.product_title || it.title)) || fallback || '';
  }
  /* one add: the items go in one request; then the cart is read. A refused add throws (with the store's reason); an
     add the store confirmed stays confirmed even when the read after it fails: resolves { added, cart: null } */
  function add(items) {
    return request('cart/add.js', { items: items }).then(function (res) {
      var b = res.body;
      if (!res.ok || !b || !(Array.isArray(b.items) ? b.items.length : b.id)) throw failure(res);
      /* the old cart is no longer the truth: until a read succeeds the bag shows what the store confirmed in this add */
      return readCart().then(function (c) { setCart(c); return { added: b, cart: c }; },
        function () { cart = null; partial = (b.items || [b]).slice(); return { added: b, cart: null }; });
    });
  }
  function afterAdd(r, from, name) {
    render();
    bag.open(from, { fresh: !!r.cart });
    if (r.cart) {
      var n = hatsIn(r.cart);
      announce(fill(SAY.addedCount, { name: name, items: n + (n === 1 ? ' hat' : ' hats'), subtotal: money(r.cart.total_price) }));
    } else {
      /* the store took it; the rest of the bag could not be read, so no count or subtotal is guessed */
      announce(fill(SAY.added, { name: name }));
      bagError((COPY.unconfirmed || 'We could not confirm the saved cart. Reload it before checkout.'), true);
    }
  }
  function track(name, data) {
    try { if (win.FlipsideAnalytics && typeof win.FlipsideAnalytics.track === 'function') win.FlipsideAnalytics.track(name, data); } catch (e) {}
  }
  function formError(form, m) {
    var e = form.querySelector('[data-cult-error]');
    if (!e) { say(m); return; }
    e.hidden = false; e.textContent = m;   /* unhide, then write: a hidden alert is not in the accessibility tree */
    e.focus();
  }
  function setFormBusy(form, v) {
    form.__busy = v;
    form.setAttribute('aria-busy', String(v));
    var ids = form.id ? pick('button[form="' + form.id + '"]') : [];
    $$('button[type="submit"], [data-cult-submit]', form).concat(ids).forEach(function (b) {
      if (v) b.setAttribute('aria-disabled', 'true'); else b.removeAttribute('aria-disabled');
    });
  }
  function submitForm(form, submitter) {
    if (form.__busy) return;
    var err = form.querySelector('[data-cult-error]'); if (err) { err.hidden = true; err.textContent = ''; }
    var item = itemFromForm(form);
    if (!item.id) { HTMLFormElement.prototype.submit.call(form); return; }
    var dollars = 0;
    if (form.getAttribute('data-cult-support') === 'true' && supportHook && typeof supportHook.amount === 'function') {
      dollars = supportHook.amount(form);
      if (dollars === null) return;          /* the page says what is wrong with the amount, and where */
      dollars = Number(dollars) || 0;
      if (dollars && !whole(dollars, 1e6)) return;
    }
    if (dollars > 0 && !(SUPPORT.variant && SUPPORT.available)) { formError(form, SAY.supportUnavailable); return; }
    var items = [item];
    if (dollars > 0) items.push({ id: Number(SUPPORT.variant), quantity: dollars });
    var from = submitter && submitter.focus ? submitter : (form.querySelector('[data-cult-submit]') || form);
    var name = form.getAttribute('data-cult-name') || '';
    setFormBusy(form, true);
    add(items).then(function (r) {
      setFormBusy(form, false);
      if (form.getAttribute('data-cult-track-success') === 'true') {
        track('flipside_add_to_cart_success', { source: 'cult-buy', form: form.id || 'cult-buy', variant_id: String(item.id),
          quantity: item.quantity, tip_amount: dollars, product_title: addedName(r.added, name), currency: 'USD' });
      }
      if (dollars > 0 && supportHook && typeof supportHook.reset === 'function') { try { supportHook.reset(form); } catch (e) {} }
      afterAdd(r, from, addedName(r.added, name));
    }).catch(function (e) {
      setFormBusy(form, false);
      if (e && e.challenged) { HTMLFormElement.prototype.submit.call(form); return; }
      formError(form, (e && e.reason) || SAY.addFailed);
    });
  }
  var bag = {
    /* open(from?): show the bag; focus returns to `from` (or whatever had focus) when it closes. It re-reads the cart
       unless it was just read. */
    open: function (from, opts) {
      drawer = drawer || $('#cart'); if (!drawer) return;
      if (CFG.cartPage) { if (win.location.pathname.replace(/\/$/, '') !== url('cart').replace(/\/$/, '')) win.location.href = url('cart'); return; }
      setMenu(false);
      if (drawer.hidden) {
        lastFocus = from && from.focus ? from : doc.activeElement;
        renderList();
        drawer.hidden = false;
        var x = $('.x', drawer); if (x) x.focus();
        doc.addEventListener('keydown', trap);
      } else {
        renderList();
      }
      if (!opts || !opts.fresh) {
        refresh().then(function (c) {
          blocked = false; bagError('');
          if (drawer.hidden) { renderList(); return; }
          renderList();
          return tidy(c, true).then(function (t) { if (t !== c) { setCart(t); renderList(); } });
        }).catch(function (e) {
          if (e && e.challenged) reloadTo = url('cart');
          if (!cart) bagError(COPY.unconfirmed || 'We could not confirm the saved cart. Reload it before checkout.', true);
        });
      }
    },
    close: function () {
      if (!drawer || drawer.hidden) return;
      drawer.hidden = true; doc.removeEventListener('keydown', trap);
      if (lastFocus && lastFocus.focus && doc.contains(lastFocus)) lastFocus.focus();
    },
    refresh: refresh,
    /* hats only: a support line is not an item */
    count: function () { return cart ? hatsIn(cart) : (knownCount || 0); },
    subtotal: function () { return cart ? cart.total_price / 100 : 0; },
    lines: function () { return cart ? viewLines(cart.items).map(function (l) { return Object.assign({}, l); }) : []; },
    /* add(key, qty = 1): a hat, by the page's key (usa250, xx). Resolves true when the store took it. Does not open. */
    add: function (key, qty) {
      qty = qty == null ? 1 : Number(qty);
      var item = isProduct(key) && whole(qty, 999) ? itemFor(key, qty) : null;
      if (!item) return Promise.resolve(false);
      return add([item]).then(function () { render(); return true; }, function () { return false; });
    },
    /* addSupport(dollars): "Extra support for Jamal", whole dollars, 100% to Jamal. It rides with the XX, so with no XX
       in the bag it is refused (false). */
    addSupport: function (dollars) {
      var a = Number(dollars);
      if (!whole(a, 1e6) || !SUPPORT.variant || !SUPPORT.available) return Promise.resolve(false);
      return refresh().then(function (c) {
        if (!hasXX(c)) return false;
        return add([{ id: Number(SUPPORT.variant), quantity: a }]).then(function () { render(); return true; });
      }).catch(function () { return false; });
    },
    /* buy(key, { support, from }): the hat (and the support with it, in the same request), then the bag */
    buy: function (key, o) {
      o = o || {};
      var item = isProduct(key) ? itemFor(key, 1) : null;
      if (!item) return Promise.resolve(false);
      var items = [item], s = Number(o.support) || 0;
      if (s && whole(s, 1e6) && SUPPORT.variant && SUPPORT.available) items.push({ id: Number(SUPPORT.variant), quantity: s });
      return add(items).then(function (r) { afterAdd(r, o.from, addedName(r.added, products[key].name)); return true; },
        function (e) { say((e && e.reason) || SAY.addFailed); return false; });
    },
    submit: submitForm
  };
  function wireBag() {
    drawer = $('#cart');
    var list = $('#cart-items');
    if (list) list.addEventListener('click', onBagClick);
    if (drawer) {
      $$('[data-close]', drawer).forEach(function (b) { b.addEventListener('click', function () { bag.close(); }); });
      var rl = $('[data-cart-reload]', drawer); if (rl) rl.addEventListener('click', function () { if (reloadTo) win.location.href = reloadTo; else win.location.reload(); });
    }
    /* the Bag control is a link to /cart without JavaScript; with it, it opens the bag (except on the cart page) */
    $$('.bag-btn').forEach(function (b) {
      if (CFG.cartPage) return;
      b.setAttribute('role', 'button'); b.setAttribute('aria-haspopup', 'dialog'); b.setAttribute('aria-controls', 'cart');
      b.addEventListener('click', function (e) { if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return; e.preventDefault(); bag.open(b); });
      b.addEventListener('keydown', function (e) { if (e.key === ' ') { e.preventDefault(); bag.open(b); } });
    });
    /* buy forms: the capture listener in fs-analytics sees the submit first (flipside_add_to_cart), then this */
    doc.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || !f.matches || !f.matches('form[data-cult-add]') || !win.fetch || e.defaultPrevented) return;
      e.preventDefault();
      submitForm(f, e.submitter || null);
    });
    /* The header count is Liquid's, from the page as served; no cart read at load (every page view would cost one, and
       the store's bot check counts cart requests). The cart is read when the bag opens, when a page comes back from the
       back-forward cache, and when the tab comes back after a while (another tab may have changed the cart). */
    var lastRead = Date.now();
    var settle = function () { lastRead = Date.now(); refresh().catch(function () {}); };
    doc.addEventListener('visibilitychange', function () { if (doc.visibilityState === 'visible' && Date.now() - lastRead > 60000) settle(); });
    win.addEventListener('pageshow', function (e) { if (e.persisted) settle(); });
  }

  /* ---------- the vitrine: a 3D hat in a full-screen case, loaded on request ---------- */
  var vit = null, vFrom = null, vSrc = null, vInst = null;
  function vitKey(e) {
    if (e.key === 'Escape') { e.preventDefault(); closeVit(); return; }
    if (e.key !== 'Tab') return;
    var f = $$('button, [href], model-viewer, [tabindex]:not([tabindex="-1"])', vit).filter(function (x) { return !x.disabled && (x.offsetParent !== null || x.tagName === 'MODEL-VIEWER'); });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && doc.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && doc.activeElement === last) { e.preventDefault(); first.focus(); }
    else if (!vit.contains(doc.activeElement)) { e.preventDefault(); first.focus(); }
  }
  function openVit(btn) {
    vit = vit || $('#vitrine');
    var src = btn && btn.getAttribute && btn.getAttribute('data-src');
    if (!vit || !src) return;
    var stage = $('#vitrine-stage', vit), title = $('#vitrine-title', vit), foot = $('#vitrine-foot', vit), x = $('[data-vitrine-close]', vit);
    var opts = { src: src, iosSrc: btn.getAttribute('data-ios-src') || null, poster: btn.getAttribute('data-poster') || null, alt: btn.getAttribute('data-alt') || null, eager: true,
      /* data-hat: the product's handle (snippets/cult-model-3d); hat3d.js keys the model's look on it, not on the URL */
      hat: btn.getAttribute('data-hat') || null,
      /* the button may frame the hat (data-orbit, a camera-orbit such as "20deg 71deg 104%") and turn it (data-spin,
         degrees a second; hat3d.js rests at 0, Section 10.1) */
      orbit: btn.getAttribute('data-orbit') || null, spin: btn.hasAttribute('data-spin') ? (parseFloat(btn.getAttribute('data-spin')) || 0) : null };
    vFrom = btn;
    if (title) title.textContent = btn.getAttribute('data-title') || '3D view';
    if (foot) foot.textContent = btn.getAttribute('data-foot') || '';
    setMenu(false); bag.close();
    if (vit.hidden) {
      vit.hidden = false; doc.documentElement.style.overflow = 'hidden';
      doc.addEventListener('keydown', vitKey);
    }
    if (x) x.focus();
    Promise.all([css(asset('hat3d.css')), load(asset('hat3d.js'))]).then(function () {
      if (vit.hidden || !stage || !win.FlipsideHat3D) return;
      if (vInst && vSrc === src) return;
      if (vInst && vInst.destroy) { try { vInst.destroy(); } catch (e) {} }
      stage.innerHTML = '';
      vSrc = src; vInst = win.FlipsideHat3D.mount(stage, opts);
    }, function () {});
  }
  function closeVit() {
    if (!vit || vit.hidden) return;
    vit.hidden = true; doc.documentElement.style.overflow = '';
    doc.removeEventListener('keydown', vitKey);
    if (vFrom && vFrom.focus && doc.contains(vFrom)) vFrom.focus();
  }

  /* the header's height, site.css --bar (52px, 64px from 900px), read from the media query: asking the computed style
     here, while the page is still loading, would force a style pass over the whole document before its first paint */
  function barPx() { return isDesk() ? 64 : 52; }

  /* ---------- markup hooks ---------- */
  /* svg[data-strikes="50"]: fifty strokes in fives, every five struck through. Bone, not gold: these are gone. */
  function drawStrikes(svg) {
    if (svg.__fsStrikes) return; svg.__fsStrikes = true;
    var n = parseInt(svg.getAttribute('data-strikes'), 10) || 50, groups = Math.ceil(n / 5), html = '';
    for (var g = 0; g < groups; g++) {
      var x0 = g * 30 + 2, inG = Math.min(5, n - g * 5);
      for (var k = 0; k < inG; k++) { var x = x0 + 2 + k * 4.6; html += '<line x1="' + x + '" y1="3" x2="' + x + '" y2="19" stroke="rgba(239,230,212,.42)" stroke-width="1.7" stroke-linecap="round"/>'; }
      if (inG === 5) html += '<line x1="' + (x0 - 1) + '" y1="17" x2="' + (x0 + 23) + '" y2="5" stroke="rgba(239,230,212,.92)" stroke-width="2.2" stroke-linecap="round"/>';
    }
    if (!svg.getAttribute('viewBox')) svg.setAttribute('viewBox', '0 0 ' + (groups * 30 - 2) + ' 22');
    if (!svg.hasAttribute('role') && !svg.hasAttribute('aria-label')) { svg.setAttribute('aria-hidden', 'true'); svg.setAttribute('focusable', 'false'); }
    svg.innerHTML = html;
  }
  /* .spin-ring rests while it is off screen */
  var ringIO = hasIO ? new IntersectionObserver(function (es) { es.forEach(function (x) { x.target.classList.toggle('is-off', !x.isIntersecting); }); }) : null;
  function wireRing(el) { if (el.__fsRing) return; el.__fsRing = true; if (ringIO) ringIO.observe(el); }
  /* img[data-crest]: the turning crest; reduced motion, or a paused visitor, gets the still frame */
  function wireCrest(img) { if (img.__fsCrest) return; img.__fsCrest = true; frame(img); }

  /* ---------- motion (WCAG 2.2.2): the turning crest and its rings keep turning by default. One pause control, the
     same everywhere (.pause), 44px to touch. Compact by default (.pause--compact): a slim ring with the pause or play
     glyph and no visible word. data-motion-toggle="full" gives the pill with the word for what a press does, "Pause"
     and then "Play". Either way its name says it: "Pause the turning crest", then "Play the turning crest". A press
     stops every ring and holds every img[data-crest] on its still frame (POSTER); the choice is remembered from page to
     page (localStorage flipside-motion-v1). With reduced motion nothing turns, so the control stays hidden.
     Place it where it belongs: <button type="button" data-motion-toggle hidden></button> (data-motion-name="..." names
     what it stops; default "the turning crest"). site.js fills it, shows it and wires it. With none on the page, a crest
     gets one (.pause.pause--float) just below its group: the nearest [data-motion] around the ring or crest, else its
     nearest aria-hidden wrapper, else its parent. A group whose parent holds some other aria-pressed toggle is the
     page's own business, and is left alone. Scripts follow along with Flipside.motion.on(fn) or 'flipside:motion'.
     No aria-pressed: the label says the action and changes with it, and a toggle button's name must not change
     (WAI-ARIA APG, Button pattern), so this is a plain button whose name is "Pause ..." or "Play ...". ---------- */
  var MKEY = 'flipside-motion-v1', still = false, managed = [], toggles = [], motionFns = [];
  try { still = win.localStorage.getItem(MKEY) === 'still'; } catch (e) {}
  var PAUSE_ICON = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path class="pause__bars" d="M8.5 6v12M15.5 6v12"/><path class="pause__play" d="M8 5.5v13l11-6.5z"/></svg>';
  function frame(img) {
    var live = img.__fsLive || (img.__fsLive = { src: img.getAttribute('src'), dsrc: img.getAttribute('data-src'), srcset: img.getAttribute('srcset') });
    if (reduce || (still && img.__fsManaged)) {
      if (img.hasAttribute('srcset')) img.removeAttribute('srcset');
      if (live.dsrc) img.setAttribute('data-src', POSTER);      /* a page that loads it later loads the still frame */
      if (img.getAttribute('src') && img.getAttribute('src') !== POSTER) img.setAttribute('src', POSTER);
      else if (reduce && !live.dsrc && !img.getAttribute('src')) img.setAttribute('src', POSTER);
    } else if (img.__fsManaged) {
      if (live.dsrc) img.setAttribute('data-src', live.dsrc);
      if (live.srcset) img.setAttribute('srcset', live.srcset);
      if (img.getAttribute('src') === POSTER) img.setAttribute('src', live.src || live.dsrc);
    }
  }
  function paintToggle(b) {
    b.classList.toggle('is-still', still);
    if (b.__fsLabel) b.__fsLabel.textContent = still ? 'Play' : 'Pause';
  }
  function paintMotion() {
    managed.forEach(function (el) { if (el.tagName === 'IMG') frame(el); else el.classList.toggle('is-still', still); });
    toggles.forEach(paintToggle);
  }
  function setStill(v) {
    v = !!v; var changed = v !== still; still = v;
    try { if (still) win.localStorage.setItem(MKEY, 'still'); else win.localStorage.removeItem(MKEY); } catch (e) {}
    paintMotion();
    if (!changed) return;
    motionFns.slice().forEach(function (fn) { try { fn(still); } catch (e) {} });
    try { doc.dispatchEvent(new CustomEvent('flipside:motion', { detail: { still: still } })); } catch (e) {}
  }
  function onMotion(fn) {
    if (typeof fn !== 'function') return function () {};
    motionFns.push(fn);
    return function () { motionFns = motionFns.filter(function (f) { return f !== fn; }); };
  }
  function adopt(b) {
    if (b.__fsMotion) return; b.__fsMotion = true; toggles.push(b);
    if (b.tagName === 'BUTTON' && !b.getAttribute('type')) b.type = 'button';
    b.classList.add('pause'); b.removeAttribute('aria-pressed'); b.removeAttribute('aria-label');
    if ((b.getAttribute('data-motion-toggle') || '').trim() !== 'full') b.classList.add('pause--compact');
    b.innerHTML = PAUSE_ICON + '<span class="pause__label"></span><span class="sr"> ' + esc(b.getAttribute('data-motion-name') || 'the turning crest') + '</span>';
    b.__fsLabel = $('.pause__label', b);
    /* a press here belongs to the control, not to whatever it sits on (a hero light, a drag) */
    b.addEventListener('pointerdown', function (e) { e.stopPropagation(); });
    b.addEventListener('click', function (e) { e.preventDefault(); setStill(!still); });
    paintToggle(b);
    if (!b.__fsGroup) b.hidden = false;
  }
  var mro = win.ResizeObserver ? new ResizeObserver(function (es) { es.forEach(function (x) { (x.target.__fsToggles || []).forEach(place); }); }) : null;
  function place(b) {
    var g = b.__fsGroup;
    if (!g.offsetWidth) { b.hidden = true; return; }
    b.hidden = false;
    /* just below the group, centred under it where there is room, never past the edges of its box */
    var w = b.offsetWidth, room = b.offsetParent ? b.offsetParent.clientWidth : doc.documentElement.clientWidth;
    b.style.left = Math.round(Math.max(8, Math.min(room - w - 8, g.offsetLeft + (g.offsetWidth - w) / 2))) + 'px';
    b.style.top = Math.round(g.offsetTop + g.offsetHeight + 8) + 'px';
    var z = parseInt(win.getComputedStyle(g).zIndex, 10); b.style.zIndex = isNaN(z) ? '' : String(z + 1);
  }
  function toggleFor(g) {
    var b = doc.createElement('button');
    b.type = 'button'; b.className = 'pause pause--float'; b.hidden = true;
    b.__fsGroup = g;
    g.insertAdjacentElement('afterend', b);
    adopt(b);
    var host = g.parentElement;
    (host.__fsToggles = host.__fsToggles || []).push(b);
    if (mro) mro.observe(host);
    else { var go = function () { place(b); }; if (doc.readyState === 'complete') go(); else win.addEventListener('load', go); win.addEventListener('resize', go); }
    return b;
  }
  function wireMotion(root) {
    var own = $$('[data-motion-toggle]');
    if (reduce) { own.forEach(function (b) { b.hidden = true; }); return; }
    own.forEach(adopt);
    $$('.spin-ring, img[data-crest]', root).forEach(function (el) {
      if (el.__fsMotion) return; el.__fsMotion = true;
      var g = el.closest('[data-motion]') || el.closest('[aria-hidden="true"]') || el.parentElement;
      if (!g || !g.parentElement) return;
      var theirs = $$('button[aria-pressed]', g.parentElement).some(function (b) { return !b.__fsMotion; });
      if (theirs && !own.length) return;
      el.__fsManaged = true; managed.push(el);
      if (!own.length && !g.__fsToggle) g.__fsToggle = toggleFor(g) || true;
    });
    paintMotion();
  }
  /* .sticky[data-watch][data-quiet]: on while the watched buttons are off screen, quiet over the quiet zones and the footer */
  function wireSticky(st) {
    if (st.__fsSticky) return; st.__fsSticky = true;
    var watch = pick(st.getAttribute('data-watch'));
    if (!watch.length || !hasIO) return;
    var zones = pick(st.getAttribute('data-quiet')).concat($$('.foot'));
    var inW = new Map(), inQ = new Map(), away = false, quiet = false, top = barPx(), stH = 0, pad = '';
    var paint = function () {
      var on = away && !quiet;
      st.classList.toggle('on', on); st.setAttribute('aria-hidden', String(!on));
      $$('a[href], button', st).forEach(function (b) { b.tabIndex = on ? 0 : -1; });
      /* focus is never hidden under it (WCAG 2.4.11): while it shows, anything scrolled into view (focus, anchors)
         stops above it, and a keyboard focus it has just covered moves up to clear it */
      if (on && !stH) stH = st.offsetHeight;
      var want = on ? (stH + 12) + 'px' : '';
      if (want !== pad) { pad = want; doc.documentElement.style.scrollPaddingBottom = want; }
      var a = on && doc.activeElement, r = null, kb = false;
      if (a && a !== doc.body && !st.contains(a)) { try { kb = a.matches(':focus-visible'); } catch (e) {} }
      if (kb) { r = a.getBoundingClientRect(); if (r.bottom > win.innerHeight - stH - 4 && r.top < win.innerHeight) a.scrollIntoView({ block: 'nearest' }); }
    };
    /* fully visible, below the header: a button that is cut by an edge, or sits under the header, does not count */
    var wio = new IntersectionObserver(function (en) {
      en.forEach(function (x) { inW.set(x.target, x.isIntersecting && x.intersectionRatio >= 0.999); });
      away = !watch.some(function (w) { return inW.get(w); }); paint();
    }, { threshold: [0, 1], rootMargin: (-top) + 'px 0px 0px 0px' });
    watch.forEach(function (w) { wio.observe(w); });
    var qio = new IntersectionObserver(function (en) {
      en.forEach(function (x) { inQ.set(x.target, x.isIntersecting); });
      quiet = zones.some(function (z) { return inQ.get(z); }); paint();
    });
    zones.forEach(function (z) { qio.observe(z); });
    paint();
  }
  /* .next-door: on touch screens the gold thread sews itself when the door comes into view */
  function wireDoor(el) {
    if (el.__fsDoor) return; el.__fsDoor = true;
    if (!noHover) return;
    if (!hasIO) { el.classList.add('is-sewn'); return; }
    var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { io.disconnect(); el.classList.add('is-sewn'); } }, { threshold: .6 });
    io.observe(el);
  }
  function wire(root) {
    root = root || doc;
    $$('svg[data-strikes]', root).forEach(drawStrikes);
    $$('.spin-ring', root).forEach(wireRing);
    wireMotion(root);
    $$('img[data-crest]', root).forEach(wireCrest);
    $$('.sticky[data-watch]', root).forEach(wireSticky);
    $$('.next-door', root).forEach(wireDoor);
  }

  /* ---------- the desktop header: both hats and four rooms on one line from 900px. If the links ever meet the crest
     (big type settings, odd font metrics), the header falls back to the Menu button until there is room again.
     Measured after load and on resize only. ---------- */
  function wireNavFit() {
    var bar = $('.bar'), mark = bar && $('.mark', bar), L = bar && $('.bar__l .bar__links', bar), R = bar && $('.bar__r .bar__links', bar);
    if (!mark || !L || !R || !L.lastElementChild || !R.firstElementChild) return;
    var q = false;
    var fit = function () {
      q = false;
      bar.classList.remove('bar--tight');
      if (!isDesk()) return;
      var m = mark.getBoundingClientRect(), l = L.lastElementChild.getBoundingClientRect(), r = R.firstElementChild.getBoundingClientRect();
      bar.classList.toggle('bar--tight', l.right > m.left - 8 || r.left < m.right + 8);
    };
    var ask = function () { if (!q) { q = true; requestAnimationFrame(fit); } };
    win.addEventListener('resize', ask);
    if (doc.readyState === 'complete') ask(); else win.addEventListener('load', ask);
    if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(function () { if (doc.readyState === 'complete') ask(); });
  }

  /* ---------- the reading thread: a running stitch sews across under the bar as you read ---------- */
  function wireThread() {
    var th = doc.createElement('div'); th.className = 'thread'; th.setAttribute('aria-hidden', 'true'); doc.body.appendChild(th);
    /* Where the browser can tie it to the scroll itself, site.css runs it on a scroll timeline: no script at all. */
    if (win.CSS && CSS.supports && CSS.supports('animation-timeline: scroll()')) return;
    /* Otherwise it stays deaf to scroll and resize until the page has loaded and painted once more, so it never pulls
       the first layout into a load-time task. Then it reads once, and follows the scroll from there. */
    var q = false, live = false;
    var set = function () { q = false; var d = doc.documentElement, max = d.scrollHeight - d.clientHeight; th.style.setProperty('--read', max > 0 ? Math.min(1, win.scrollY / max).toFixed(4) : 0); };
    var ask = function () { if (live && !q) { q = true; requestAnimationFrame(set); } };
    var wake = function () { requestAnimationFrame(function () { live = true; set(); }); };
    win.addEventListener('scroll', ask, { passive: true });
    win.addEventListener('resize', ask);
    if (doc.readyState === 'complete') wake(); else win.addEventListener('load', wake);
  }

  /* ---------- clicks: in-page anchors, a [data-add] button outside any buy form, the vitrine ---------- */
  function onClick(e) {
    if (e.defaultPrevented || e.button > 0 || !e.target.closest) return;
    var t = e.target.closest('[data-add],[data-vitrine]');
    if (t) {
      if (t.hasAttribute('data-add')) {
        /* a submit button of a buy form belongs to the form; any other [data-add="usa250"|"xx"] buys straight away */
        if (t.form && t.form.hasAttribute('data-cult-add')) return;
        var k = t.getAttribute('data-add');
        if (isProduct(k)) { e.preventDefault(); bag.buy(k, { from: t }); }
      } else if (t.getAttribute('data-src')) { e.preventDefault(); openVit(t); }
      return;
    }
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest('a[href^="#"]'); if (!a) return;
    var id = a.getAttribute('href').slice(1), el = null;
    try { el = id && doc.getElementById(decodeURIComponent(id)); } catch (err) { el = null; }
    if (!el) return;
    e.preventDefault();
    el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    if (history.pushState) history.pushState(null, '', '#' + id);
    if (el.tabIndex < 0 && !el.hasAttribute('tabindex')) el.setAttribute('tabindex', '-1');
    el.focus({ preventScroll: true });
  }

  win.Flipside = {
    version: '1.1.0-shopify',
    reduce: reduce, hasIO: hasIO, isDesk: isDesk, ready: ready, near: near,
    load: load, css: css, asset: asset, assetBase: ASSET_BASE, assetMap: ASSET_MAP, routes: ROUTES, config: CFG,
    stock: stock, say: say, bag: bag, products: products, POSTER: POSTER,
    support: { register: function (h) { supportHook = h && typeof h === 'object' ? h : null; } },
    motion: { still: function () { return still; }, set: setStill, on: onMotion },
    wire: wire, vitrine: { open: openVit, close: closeVit }
  };
  /* for the legacy sections: the hat count (a support line is not a hat), and "open the cart drawer" */
  win.FlipsideCartCount = function (c) { return c && Array.isArray(c.items) ? hatsIn(c) : (Number(c && c.item_count) || 0); };
  win.openCartDrawer = function () { bag.open(); };

  wireMenu();
  wireNavFit();
  wireBag();
  var vx = $('#vitrine [data-vitrine-close]'); if (vx) vx.addEventListener('click', closeVit);
  wire(doc);
  wireThread();
  doc.addEventListener('click', onClick);

  /* ---------- Shopify's wallet buttons, after the first paint ----------
     The product forms' dynamic checkout button and the bag's wallets arrive as <template data-cult-defer> and go in
     once the page has painted. Their Shop Pay element frames shop.app, whose CSP refuses the frame; while the page's
     cross-document view transition is opted in, Chrome holds the page's first paint as long as that frame is pending
     (1.5 to 2.5 s in Lighthouse runs). Put in after the first contentful paint, it holds nothing. The slots keep their
     size, so nothing moves when the buttons arrive. */
  function inflateWallets() {
    if (inflateWallets.done) return;
    inflateWallets.done = true;
    Array.prototype.forEach.call(doc.querySelectorAll('template[data-cult-defer]'), function (t) {
      if (t.parentNode) t.parentNode.replaceChild(doc.importNode(t.content, true), t);
    });
  }
  (function () {
    var go = function () { setTimeout(inflateWallets, 0); };
    try {
      var types = win.PerformanceObserver && PerformanceObserver.supportedEntryTypes;
      if (types && types.indexOf('paint') > -1) {
        var po = new PerformanceObserver(function (list) {
          if (list.getEntriesByName('first-contentful-paint').length) { po.disconnect(); go(); }
        });
        po.observe({ type: 'paint', buffered: true });
      } else win.addEventListener('load', go);
    } catch (e) { win.addEventListener('load', go); }
    /* a safety net: a page that never reports a contentful paint (a background tab) still gets its buttons */
    win.addEventListener('load', function () { setTimeout(inflateWallets, 3000); });
  })();

  /* the page scripts that queued on FlipsideReady (layout head shim) run now, in order; later calls run at once */
  var queued = win.__fsq || [];
  var run = function (fn) { try { fn(win.Flipside); } catch (e) { if (win.console && console.error) console.error(e); } };
  win.FlipsideReady = function (fn) { if (typeof fn === 'function') run(fn); };
  win.__fsq = { push: function (fn) { if (typeof fn === 'function') run(fn); } };
  queued.forEach(run);
})(window, document);
